(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (window.innerWidth >= 750) {
    document.querySelectorAll('.footer__column-details').forEach(details => {
      details.open = true;
    });
  }

  window.addEventListener('resize', () => {
    const details = document.querySelectorAll('.footer__column-details');
    if (window.innerWidth >= 750) {
      details.forEach(detail => {
        detail.open = true;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.site-header');
    
    if (!header) return;

    // Announcement Slider with hide/show on scroll
    const sliderWrapper = document.querySelector('.announcement-slider-wrapper');
    if (sliderWrapper) {
      const slides = sliderWrapper.querySelectorAll('.announcement-slide');
      const dots = sliderWrapper.querySelectorAll('.announcement-dot');
      const prevBtn = sliderWrapper.querySelector('.announcement-prev');
      const nextBtn = sliderWrapper.querySelector('.announcement-next');
      const autoplay = sliderWrapper.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(sliderWrapper.dataset.autoplaySpeed) || 5000;
      const hideOnScroll = sliderWrapper.dataset.hideOnScroll === 'true';
      const displayMode = sliderWrapper.dataset.displayMode || 'slider';
      const marqueeSpeed = parseInt(sliderWrapper.dataset.marqueeSpeed) || 40;
      
      let currentSlide = 0;
      let autoplayInterval;
      let lastScrollY = window.scrollY;
      let ticking = false;

      // Initialize Marquee Mode
      if (displayMode === 'marquee') {
        const slider = sliderWrapper.querySelector('.announcement-slider');
        
        // Combine all announcement texts
        const allTexts = [];
        slides.forEach(slide => {
          const content = slide.querySelector('.announcement-content');
          if (content) {
            allTexts.push(content.innerHTML);
          }
        });
        
        // Create the scrolling text with bullet separators
        const combinedText = allTexts.join('&nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;') 
  + '&nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;';
        
        // Clear existing content
        slider.innerHTML = '';
        
        // Create marquee slide with proper background
        const marqueeSlide = document.createElement('div');
        marqueeSlide.className = 'announcement-slide active';
        marqueeSlide.style.cssText = `
          background: ${slides[0].style.getPropertyValue('--announcement-bg-color') || '#000'};
          color: ${slides[0].style.getPropertyValue('--announcement-text-color') || '#fff'};
          min-height: ${slides[0].style.getPropertyValue('--announcement-height') || '40px'};
        `;
        
        // Create the marquee content wrapper
        const marqueeWrapper = document.createElement('div');
        marqueeWrapper.className = 'announcement-content';
        marqueeWrapper.style.cssText = `
          display: block;
          width: 100%;
          overflow: hidden;
          font-size: ${slides[0].style.getPropertyValue('--announcement-font-size') || '12px'};
          color: ${slides[0].style.getPropertyValue('--announcement-text-color') || '#fff'};
        `;
        
        // Create the scrolling track
        const marqueeTrack = document.createElement('div');
        marqueeTrack.className = 'marquee-track';
        
        // Create a temporary span to measure text width
        const tempSpan = document.createElement('span');
        tempSpan.className = 'marquee-text';
        tempSpan.innerHTML = combinedText;
        tempSpan.style.cssText = 'display: inline-block; white-space: nowrap; visibility: hidden; position: absolute;';
        marqueeWrapper.appendChild(tempSpan);
        marqueeSlide.appendChild(marqueeWrapper);
        slider.appendChild(marqueeSlide);
        
        // Wait for next frame to measure
        requestAnimationFrame(() => {
          const textWidth = tempSpan.offsetWidth;
          const viewportWidth = window.innerWidth;
          
          // Calculate how many copies we need (at least 3x viewport width for smooth scrolling)
          const minWidth = viewportWidth * 3;
          const copiesNeeded = Math.ceil(minWidth / textWidth) + 1;
          
          // Remove temp span
          tempSpan.remove();
          
          // Now create the actual track with proper number of copies
          marqueeTrack.innerHTML = '';
          marqueeTrack.style.cssText = 'display: inline-flex; width: max-content;';
          
          for (let i = 0; i < copiesNeeded; i++) {
            const span = document.createElement('span');
            span.className = 'marquee-text';
            span.innerHTML = combinedText;
            span.style.cssText = 'display: inline-block; white-space: nowrap;';
            marqueeTrack.appendChild(span);
          }
          
          marqueeWrapper.appendChild(marqueeTrack);
          
          // Calculate the percentage to move (move by one copy's worth)
          const movePercentage = (100 / copiesNeeded);
          
          // Apply animation with dynamic keyframes
          const styleSheet = document.createElement('style');
          styleSheet.textContent = `
            @keyframes marqueeScrollDynamic {
              0% { transform: translateX(0); }
              100% { transform: translateX(-${movePercentage}%); }
            }
          `;
          document.head.appendChild(styleSheet);
          
          marqueeTrack.style.animation = `marqueeScrollDynamic ${marqueeSpeed}s linear infinite`;
        });
      }

      function goToSlide(index) {
        if (displayMode === 'marquee') return;
        
        slides.forEach(slide => slide.classList.remove('active'));
        dots.forEach(dot => dot.classList.remove('active'));
        
        if (slides[index]) slides[index].classList.add('active');
        if (dots[index]) dots[index].classList.add('active');
        
        currentSlide = index;
        
        // Update announcement height CSS variable for header positioning
        setTimeout(() => {
          const height = sliderWrapper.offsetHeight;
          document.documentElement.style.setProperty('--announcement-height', height + 'px');
        }, 50);
      }

      function nextSlide() {
        if (displayMode === 'marquee') return;
        const next = (currentSlide + 1) % slides.length;
        goToSlide(next);
      }

      function prevSlide() {
        if (displayMode === 'marquee') return;
        const prev = (currentSlide - 1 + slides.length) % slides.length;
        goToSlide(prev);
      }

      function startAutoplay() {
        if (displayMode === 'marquee') return;
        if (autoplay && slides.length > 1) {
          autoplayInterval = setInterval(nextSlide, autoplaySpeed);
        }
      }

      function stopAutoplay() {
        if (displayMode === 'marquee') return;
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
        }
      }

      // Dot navigation
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          goToSlide(index);
          stopAutoplay();
          startAutoplay();
        });
      });

      // Arrow navigation
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          prevSlide();
          stopAutoplay();
          startAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          nextSlide();
          stopAutoplay();
          startAutoplay();
        });
      }

      // Pause on hover
      sliderWrapper.addEventListener('mouseenter', stopAutoplay);
      sliderWrapper.addEventListener('mouseleave', startAutoplay);

      // Scroll direction detection - Hide on scroll down, show on scroll up
      if (hideOnScroll) {
        function handleScroll() {
          // Don't change header position when drawer is open
          if (document.body.classList.contains('drawer-open')) {
            ticking = false;
            return;
          }
          
          const currentScrollY = window.scrollY;
          const isHeaderFixed = header.classList.contains('header-always-show');
          
          if (currentScrollY <= 5) {
            // At the very top of page - always show announcement and position header below it
            sliderWrapper.classList.remove('hidden');
            
            if (isHeaderFixed) {
              const announcementHeight = sliderWrapper.offsetHeight;
              header.style.top = announcementHeight + 'px';
            }
          } else if (currentScrollY > lastScrollY) {
            // Scrolling down - hide announcement and move header to top
            sliderWrapper.classList.add('hidden');
            
            if (isHeaderFixed) {
              header.style.top = '0';
            }
          } else {
            // Scrolling up but NOT at top yet - keep announcement hidden and header at top
            sliderWrapper.classList.add('hidden');
            
            if (isHeaderFixed) {
              header.style.top = '0';
            }
          }
          
          lastScrollY = currentScrollY;
          ticking = false;
        }

        window.addEventListener('scroll', () => {
          if (!ticking) {
            window.requestAnimationFrame(handleScroll);
            ticking = true;
          }
        });
        
        // Check initial scroll position on page load
        window.requestAnimationFrame(handleScroll);
      } else {
        // hideOnScroll is OFF - FORCE announcement to always stay visible
        // Remove hidden class if it somehow got added
        sliderWrapper.classList.remove('hidden');
        
        // Clear any inline styles that might hide it
        sliderWrapper.style.transform = '';
        sliderWrapper.style.opacity = '';
        sliderWrapper.style.visibility = '';
        
        // Set up a scroll listener that ENFORCES visibility
        window.addEventListener('scroll', () => {
          // Always remove hidden class
          if (sliderWrapper.classList.contains('hidden')) {
            sliderWrapper.classList.remove('hidden');
          }
          
          // Always ensure proper positioning
          const height = sliderWrapper.offsetHeight;
          if (header.classList.contains('header-always-show') && height > 0) {
            header.style.top = height + 'px';
          }
        });
      }

      // Initialize
      if (displayMode === 'slider') {
        goToSlide(0);
        startAutoplay();
      }
      
      // Set initial announcement height for fixed header positioning
      setTimeout(() => {
        const height = sliderWrapper.offsetHeight;
        document.documentElement.style.setProperty('--announcement-height', height + 'px');
        
        // Don't change header position when drawer is open
        if (document.body.classList.contains('drawer-open')) {
          return;
        }
        
        // Position fixed header
        if (header.classList.contains('header-always-show')) {
          if (hideOnScroll) {
            // When Hide on Scroll is ON - position based on scroll
            const currentScrollY = window.scrollY;
            if (currentScrollY <= 5 && !sliderWrapper.classList.contains('hidden')) {
              header.style.top = height + 'px';
            } else {
              header.style.top = '0';
            }
          } else {
            // When Hide on Scroll is OFF - ALWAYS keep header below announcement
            header.style.top = height + 'px';
          }
        }
      }, 100);
      
      // Update height on window resize
      window.addEventListener('resize', () => {
        const height = sliderWrapper.offsetHeight;
        document.documentElement.style.setProperty('--announcement-height', height + 'px');
        
        // Don't change header position when drawer is open
        if (document.body.classList.contains('drawer-open')) {
          return;
        }
        
        // Update header position if it's fixed
        if (header.classList.contains('header-always-show')) {
          if (hideOnScroll) {
            // Only update if announcement is visible
            if (!sliderWrapper.classList.contains('hidden')) {
              header.style.top = height + 'px';
            }
          } else {
            // When Hide on Scroll is OFF - ALWAYS keep header below announcement
            header.style.top = height + 'px';
          }
        }
      });
    }

    // Header scroll effects
    const isTransparentEnabled = header.classList.contains('header-transparent-enabled');
    
    // Check if transparent header should be active on current page
    function shouldShowTransparentHeader() {
      if (!isTransparentEnabled) return false;
      
      // Get individual page settings from data attributes
      const transparentOnHome = header.dataset.transparentHome === 'true';
      const transparentOnCollection = header.dataset.transparentCollection === 'true';
      const transparentOnProduct = header.dataset.transparentProduct === 'true';
      const transparentOnPage = header.dataset.transparentPage === 'true';
      const specificPages = header.dataset.transparentSpecific || '';
      
      // Get current page template from body classes
      const bodyClasses = document.body.className;
      const isHome = bodyClasses.includes('template-index') || window.location.pathname === '/' || window.location.pathname === '';
      const isCollection = bodyClasses.includes('template-collection');
      const isProduct = bodyClasses.includes('template-product');
      const isPage = bodyClasses.includes('template-page');
      
      // Check if current page type is enabled for transparent header
      if (isHome && transparentOnHome) return true;
      if (isCollection && transparentOnCollection) return true;
      if (isProduct && transparentOnProduct) return true;
      if (isPage && transparentOnPage) return true;
      
      // Check if current URL matches any specific pages
      if (specificPages) {
        const currentPath = window.location.pathname;
        const pageList = specificPages.split('\n').map(p => p.trim()).filter(p => p);
        
        for (let pagePath of pageList) {
          // Remove trailing slashes for comparison
          const normalizedPagePath = pagePath.replace(/\/$/, '');
          const normalizedCurrentPath = currentPath.replace(/\/$/, '');
          
          if (normalizedCurrentPath === normalizedPagePath) {
            return true;
          }
        }
      }
      
      return false;
    }
    
    // Store original values from inline styles (from Liquid variables)
    const originalBgColor = getComputedStyle(header).getPropertyValue('--header-bg-color').trim();
    const originalBorderColor = getComputedStyle(header).getPropertyValue('--header-border-color').trim();
    const originalTextColor = getComputedStyle(header).getPropertyValue('--header-text-color').trim();
    const originalNavColor = getComputedStyle(header).getPropertyValue('--nav-text-color').trim();
    const originalCartCountColor = getComputedStyle(header).getPropertyValue('--cart-count-color').trim();
    
    // Only apply transparent header logic if we're on an allowed page
    if (shouldShowTransparentHeader()) {
      // Add the header-transparent class and make it transparent
      header.classList.add('header-transparent');
      header.style.setProperty('--header-bg-color', 'transparent');
      header.style.setProperty('--header-border-color', 'var(--header-transparent-border)');
      header.style.setProperty('--header-text-color', 'var(--header-transparent-text)');
      header.style.setProperty('--nav-text-color', 'var(--header-transparent-nav)');
      header.style.setProperty('--cart-count-color', 'var(--header-transparent-cart-count)');
    } else {
      // Not on a transparent page - restore original background colors
      header.classList.remove('header-transparent');
      // Reset to original values so the header has its background
      header.style.setProperty('--header-bg-color', originalBgColor);
      header.style.setProperty('--header-border-color', originalBorderColor);
      header.style.setProperty('--header-text-color', originalTextColor);
      header.style.setProperty('--nav-text-color', originalNavColor);
      header.style.setProperty('--cart-count-color', originalCartCountColor);
    }

        // ---------- Transparent header: show overlay when scrolling up ----------
    (function() {
      // Only continue if header is transparent on this page
      if (!header.classList.contains('header-transparent')) return;

      // Check enabled flag from data attribute (set via Liquid: section.settings.transparent_scroll_toggle)
      var scrollToggleEnabled = header.getAttribute('data-transparent-scroll-toggle') === 'true';
      if (!scrollToggleEnabled) return;

      // Ensure overlay exists (inserted in Part 1)
      var overlay = header.querySelector('.header-bg-overlay');
      if (!overlay) return;

      var lastY = window.scrollY || document.documentElement.scrollTop;
      var ticking = false;

      function handleTransparentScroll() {
        var curr = window.scrollY || document.documentElement.scrollTop;
        var atTop = curr <= 0;

        // When a drawer/overlay is open, avoid toggling
        if (document.body.classList.contains('drawer-open')) {
          lastY = curr;
          ticking = false;
          return;
        }

        if (atTop) {
          header.classList.remove('header-bg-visible');
        } else if (curr < lastY) {
          // Scrolling up -> show overlay/dashboard
          header.classList.add('header-bg-visible');
        } else if (curr > lastY) {
          // Scrolling down -> hide overlay
          header.classList.remove('header-bg-visible');
        }

        lastY = curr;
        ticking = false;
      }

      window.addEventListener('scroll', function() {
        if (!ticking) {
          window.requestAnimationFrame(handleTransparentScroll);
          ticking = true;
        }
      }, { passive: true });

      function initHeaderOverlayState() {
        var curr = window.scrollY || document.documentElement.scrollTop;
        if (curr <= 0) {
          header.classList.remove('header-bg-visible');
        } else {
          header.classList.remove('header-bg-visible');
        }
      }
      initHeaderOverlayState();
      window.addEventListener('pageshow', initHeaderOverlayState);
    })();


    // Search toggle functionality
    const searchToggle = document.querySelector('.search-toggle');
    if (searchToggle) {
      searchToggle.addEventListener('click', function(e) {
        e.preventDefault();
        if (window.searchDrawer && typeof window.searchDrawer.open === 'function') {
          window.searchDrawer.open();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
